import React from 'react'
import img1 from '../../images/Mask1.webp'
import img2 from '../../images/Mask2.webp'
import img3 from '../../images/farming.webp'
import img4 from '../../images/gym.webp'
import img5 from '../../images/power.webp'
import img6 from '../../images/security.webp'
import img7 from '../../images/swim.webp'
import img8 from '../../images/amenities-clubhouse.webp'
import mob1 from '../../images/golf-club-mob.webp'
import mob2 from '../../images/farming-mob.webp'
import mob3 from '../../images/gym-mob.webp'
import mob4 from '../../images/power-mob.webp'
import mob5 from '../../images/security-mob.webp'
import mob6 from '../../images/swim-mob.webp'
import { Container, Row, Col } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive';

const Amenities = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div className='amenities ' id="amenities" >
      <Container className='position-relative'>
        <img src={img2} className='img-fluid position-absolute img1' alt=""></img>
        <div className={`${isMobile ? 'text-start' : 'text-center'}`}>
          {
            isMobile ?
            <div className='px-3'>
              <h1 className='primary-color'>Everything You Need</h1>
              <h1 className='primary-color'>At IRA Aspiration</h1>
            </div>
            :

            <h1 className='primary-color'>Everything You Need at IRA Aspiration</h1>
          }
          <h6 className='mb-20 mt-2 px-3 text-capitalize'>31,000 Sft Clubhouse with World-Class Amenities</h6>
        </div>
        <Row className='amenities-list mb-2 position-relative' style={{paddingTop: '3%'}}>
          <Col lg={4} md={6} sm={6} xs={6} style={{paddingRight: !isMobile ?'unset':'5px'}} className={` ${isMobile ? 'mb-3' : 'mb-2'}`}>
            <div className='text-center amenities-card'>
              <img src={isMobile ? mob1 : img8} className='img-fluid' alt=""></img>
              <p className='text-capitalize'>Exclusive clubhouse</p>
            </div>
          </Col>
          <Col lg={4} md={6} sm={6} xs={6} style={{padding:  !isMobile ? '0px 7px' : '', paddingLeft: isMobile ? '5px' : ''}} className={` ${isMobile ? 'mb-3' : 'mb-2'}`}>
            <div className='text-center amenities-card'>
              <img src={isMobile ? mob6 : img7} className='img-fluid' alt=""></img>
              <p className='text-capitalize'>Swimming pool</p>
            </div>
          </Col>
          <Col lg={4} md={6} sm={6} xs={6} style={{paddingLeft: !isMobile ? 'unset' : '', paddingRight: isMobile ? '5px': ''}} className={` ${isMobile ? 'mb-3' : 'mb-2'}`}>
            <div className='text-center amenities-card'>
              <img src={isMobile ? mob3 : img4} className='img-fluid' alt=""></img>
              <p className='text-capitalize'>Gym & sports courts</p>
            </div>
          </Col>
        {/* </Row>
        <Row className='amenities-list position-relative'> */}
          <Col lg={4} md={6} sm={6} xs={6} style={{paddingRight: !isMobile ? 'unset': '', paddingLeft: isMobile ? '5px' : ''}} className={` ${isMobile ? 'mb-3' : 'mb-2'}`}>
            <div className='text-center amenities-card'>
              <img src={isMobile ? mob5 : img6} className='img-fluid' alt=""></img>
              <p className='text-capitalize'>24-hour security</p>
            </div>
          </Col>
          <Col lg={4} md={6} sm={6} xs={6} style={{padding:  !isMobile ? '0px 7px': '', paddingRight: isMobile ? '5px': ''}} className={` ${isMobile ? 'mb-3' : 'mb-2'}`}>
            <div className='text-center amenities-card'>
              <img src={isMobile ? mob4 : img5} className='img-fluid' alt=""></img>
              <p className='text-capitalize'>Power backup</p>
            </div>
          </Col>
          <Col lg={4} md={6} sm={6} xs={6} style={{paddingLeft: !isMobile ? 'unset' : '5px'}} className={` ${isMobile ? 'mb-3' : 'mb-2'}`}>
            <div className='text-center amenities-card'>
              <img src={isMobile ? mob2 : img3} className='img-fluid' alt=""></img>
              <p className='text-capitalize'>Landscaped gardens</p>
            </div>
          </Col>
        </Row>
        <img src={img1} className='img-fluid position-absolute img2' alt=""></img>
      </Container>
    </div>
  )
}

export default Amenities
